<div class="wrapper" #wrapper>
    <div class="content" [ngSwitch]="formLocation">
        <ng-container *ngSwitchCase="'top'">
            <div class="form-sub-section">
                <div class="form-container">
                    <input class="newsletter-submit" nbInput fullWidth type="email" id="email" name="email" placeholder="Enter your email here">
                    <button nbButton status="primary" size="tiny" class="nebular-btn-primary">Submit</button>
                </div>
            </div>
            <div class="text-1-container">
                <div class="text-1 inverted">
                    <div class="section-divider">
                        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
                        </svg>
                    </div>
                    <div>Be the first to know about our latest arrivals.  Sign up for our newsletter here.</div>
                </div>
            </div>
            <div class="text-2">We are committed to protecting your privacy</div>
        </ng-container>
        <ng-container *ngSwitchCase="'bottom'">
            <div class="text-1-container">
                <div class="text-1 inverted">
                    <div>Be the first to know about our latest arrivals.  Sign up for our newsletter here.</div>
                </div>
            </div>
            <div class="text-2">We are committed to protecting your privacy</div>
            <div class="form-sub-section">
                <div class="section-divider">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
                    </svg>
                </div>
                <div class="form-container">
                    <input class="newsletter-submit" nbInput fullWidth type="email" id="email" name="email" placeholder="Enter your email here">
                    <button nbButton status="primary" size="tiny" class="nebular-btn-primary">Submit</button>
                </div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'middle'">
            <div class="text-1 inverted">
                <div>Be the first to know about our latest arrivals.  Sign up for our newsletter here.</div>
            </div>
            <div class="form-sub-section">
                <div class="text-1-divider">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
                    </svg>
                </div>
                <div class="form-container">
                    <input class="newsletter-submit" nbInput fullWidth type="email" id="email" name="email" placeholder="Enter your email here">
                    <button nbButton status="primary" size="tiny" class="nebular-btn-primary">Submit</button>
                </div>
            </div>
            <div class="text-2">We are committed to protecting your privacy</div>
        </ng-container>
        
    </div>
</div>
